/// <reference path="DOMAttached.js" />

class CloseButton extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.safeObserve(this.el.querySelector(".TriggerControl"), "click", this.onClick.bind(this));
	}

	onClick(ev) {
		if (this.options.showLink) {
			location.href = this.options.url;
		} else {
			var ids = this.options.ids.split(",");
			for (var i = 0; i < ids.length; i++) {
				var el = document.getElementById(ids[i]);
				el.style.display = "none";
			}
		}
	}
}
